import React from 'react';
import PropTypes from 'prop-types';

import useBodyClass from '../../hooks/useBodyClass';

const Loading = ({ inline }) => {
  const bodyClass = inline ? '' : 'show-overlay';
  useBodyClass(bodyClass);

  return (
    <div className="loading-container">
      <div className={'loading ' + (inline ? 'loading--inline' : '')} />
    </div>
  );
};
Loading.propTypes = {
  inline: PropTypes.bool,
};

export default Loading;
